import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisputedOrdersModel } from '../../components/orders/disputed-orders-model';
import { OrdersModel } from '../../components/orders/orders-model';
import { BackendService } from '../../services/backend.service';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { TranslateModule } from '@ngx-translate/core';
import { TitleComponent } from 'src/app/general/components/title/title.component';
import { OrdersComponent } from '../../components/orders/orders.component';
import { PageComponent } from '../../components/page/page.component';

@Component({
  selector: 'app-disputed-orders-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    OrdersComponent,
    TitleComponent
  ],
  templateUrl: './disputed-orders-page.component.html',
  styleUrls: ['./disputed-orders-page.component.css']
})
export class DisputedOrdersPageComponent {
  disputedOrdersModel: OrdersModel;

  constructor(
      private sessionService: SessionService,
      private backendService: BackendService) {
    this.disputedOrdersModel = new DisputedOrdersModel(this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }
  }
}
